import { GettextTranslate } from './translate';
import {
  GettextTranslateOptions,
  GettextKind,
  ParseGettextExpressionResult,
} from './types';

const ARG = '"([^"]+)"';
const COUNT = '([\\w\\d\\[\\]\\.\\_\\|%$\\/]+)';

const RE_PATTERN_GETTEXT = new RegExp(`^_\\(${ARG}\\)$`),
  RE_PATTERN_PGETTEXT = new RegExp(`^P_\\(${ARG} *, *${ARG}\\)$`),
  RE_PATTERN_NGETTEXT = new RegExp(`^N_\\(${ARG} *, *${ARG} *, *${COUNT}\\)$`);

function fold(text: string): string {
  return text.replace(/[ \t]*\r?\n[ \t]*/g, ' ');
}

export function isGettextExpression(expression: string): boolean {
  expression = expression.trim();

  return (
    RE_PATTERN_GETTEXT.test(expression) ||
    RE_PATTERN_PGETTEXT.test(expression) ||
    RE_PATTERN_NGETTEXT.test(expression)
  );
}

export function parseGettextExpression(
  expression: string
): ParseGettextExpressionResult {
  expression = expression.trim();
  let match: RegExpExecArray | null;

  while ((match = RE_PATTERN_GETTEXT.exec(expression)) !== null) {
    return {
      valid: true,
      kind: GettextKind.gettext,
      msgid: fold(match[1]),
    };
  }

  while ((match = RE_PATTERN_PGETTEXT.exec(expression)) !== null) {
    return {
      valid: true,
      kind: GettextKind.pgettext,
      context: fold(match[1]),
      msgid: fold(match[2]),
    };
  }

  while ((match = RE_PATTERN_NGETTEXT.exec(expression)) !== null) {
    return {
      valid: true,
      kind: GettextKind.ngettext,
      msgid: fold(match[1]),
      plural: fold(match[2]),
      n: match[3],
    };
  }

  return {
    valid: false,
    kind: GettextKind.invalid,
    msgid: '',
  };
}
